module.exports = __webpack_public_path__ + "img/weddings_04_H.051ec22f.webp";